/* eslint-disable react/prop-types */
import React, { cloneElement, isValidElement, useCallback, useEffect, useRef } from 'react';
import { TableInlineCellEditing } from '@devexpress/dx-react-grid-material-ui';

export const INLINE_EDIT_SAVE_DELAY = 3000;

const AutoSaveInlineCell = ({ immediateCommitColumns, children, column, onBlur, onValueChange, ...props }) => {
  const saveTimeoutRef = useRef(null);
  const onBlurRef = useRef(onBlur);

  useEffect(() => {
    onBlurRef.current = onBlur;
  }, [onBlur]);

  const clearSaveTimeout = useCallback(() => {
    if (saveTimeoutRef.current === null) return;
    // eslint-disable-next-line no-undef
    window.clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = null;
  }, []);

  useEffect(() => clearSaveTimeout, [clearSaveTimeout]);

  const commit = useCallback(
    (event) => {
      clearSaveTimeout();
      onBlurRef.current?.(event);
    },
    [clearSaveTimeout]
  );

  const changeValue = useCallback(
    (nextValue) => {
      onValueChange(nextValue);
      clearSaveTimeout();
      const saveDelay = immediateCommitColumns.has(column.name) ? 0 : INLINE_EDIT_SAVE_DELAY;
      // Commit on a later task so EditingState has received the new value first.
      // eslint-disable-next-line no-undef
      saveTimeoutRef.current = window.setTimeout(commit, saveDelay);
    },
    [clearSaveTimeout, column.name, commit, immediateCommitColumns, onValueChange]
  );

  const editor = isValidElement(children) ? cloneElement(children, { onValueChange: changeValue }) : children;

  return (
    <TableInlineCellEditing.Cell {...props} column={column} onBlur={commit} onValueChange={changeValue}>
      {editor}
    </TableInlineCellEditing.Cell>
  );
};

export default AutoSaveInlineCell;
